<h2>Anbieterauswahl</h2>
<div *ngFor="let sp of serviceProviders$ | async" class="item">
  <app-service-provider-item [serviceProvider]="sp" (selected)="select(sp)"></app-service-provider-item>
</div>
